import slugify from 'react-slugify'

import { dashboards } from 'api/dashboard'
import { getIncidentBoards } from 'api/incident'
import { getReportConfigs } from 'api/reports'
import { handleApiResponse } from 'utils/request'
import { routeMapping } from 'routes'
import { buildShortcutLinkOptions } from 'components/shortcutLinks'
import { getPermission } from 'utils/permissions'

export const getSidebarShortcutPageOptions = async (workspace, detailRole) => {
  const slug = workspace && workspace.name ? slugify(workspace.name) : ''

  if (!workspace || !slug) {
    return []
  }

  const dashboardPermission = detailRole?.role && workspace?.dashboardsEnabled 
    ? getPermission('permissionDashboard', detailRole.role) 
    : ['none']
  const incidentPermission = detailRole?.role && workspace?.incidentsEnabled 
    ? getPermission('permissionIncidents', detailRole.role) 
    : ['none']
  const reportPermission = detailRole?.role && workspace?.reportsEnabled 
    ? getPermission('permissionReports', detailRole.role) 
    : ['none']

  const hasDashboardAccess = dashboardPermission.includes('read')
  const hasIncidentAccess = incidentPermission.includes('read')
  const hasReportAccess = reportPermission.includes('read')

  const promises = []
  const promiseTypes = []

  if (hasDashboardAccess) {
    promises.push(dashboards({ limit: 1000, offset: 0 }))
    promiseTypes.push('dashboards')
  }

  if (hasIncidentAccess) {
    promises.push(getIncidentBoards({ limit: 1000, offset: 0 }))
    promiseTypes.push('incidents')
  }

  if (hasReportAccess) {
    promises.push(getReportConfigs({ limit: 1000, offset: 0 }))
    promiseTypes.push('reports')
  }

  const results = await Promise.allSettled(promises)

  let dashboardsData = []
  let incidentBoardsData = []
  let reportsData = []

  results.forEach((result, index) => {
    const type = promiseTypes[index]

    if (result.status === 'fulfilled') {
      if (type === 'dashboards') {
        handleApiResponse(
          result.value,
          (data) => {
            dashboardsData = (data && data.data) || []
          },
          'dashboards',
          { showErrorNotification: false },
        )
      } else if (type === 'incidents') {
        handleApiResponse(
          result.value,
          (data) => {
            incidentBoardsData = (data && data.data) || []
          },
          'incidentBoards',
          { showErrorNotification: false },
        )
      } else if (type === 'reports') {
        handleApiResponse(
          result.value,
          (data) => {
            reportsData = (data && data.data) || []
          },
          'reportConfigs',
          { showErrorNotification: false },
        )
      }
    }
  })

  return buildShortcutLinkOptions({
    slug,
    dashboards: dashboardsData,
    incidentBoards: incidentBoardsData,
    reports: reportsData,
    paths: {
      dashboardsPath: routeMapping.DASHBOARDS.path,
      incidentsPath: routeMapping.INCIDENT.path,
      reportsPath: routeMapping.REPORTS.path,
    },
    dashboardDetailsMode: 'v2',
  })
}
